import { GetServerSideProps } from 'next'
export { NextRouteComponent as default } from '@pankod/refine-nextjs-router'
import { checkAuthentication } from '@pankod/refine-nextjs-router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import dataProvider from 'src/dataProvider'
import { authProvider } from 'src/authProvider'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { isAuthenticated, ...props } = await checkAuthentication(
    authProvider,
    context,
  )

  if (!isAuthenticated) {
    return props
  }

  const translateProps = await serverSideTranslations(context.locale ?? 'en', [
    'common',
  ])

  const { query } = context

  try {
    const data = await dataProvider(process.env.LMS_API_URL).getList({
      resource: query['resource'] as string,
    })

    return {
      props: {
        ...translateProps,
        initialData: data,
      },
    }
  } catch (error) {
    return {
      props: { ...translateProps, initialData: [] },
    }
  }
}
